import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export interface AiAssistantUsageRow {
  organization_id: string;
  organization_name: string;
  provider_mode: 'platform_openai' | 'customer_openai' | 'customer_anthropic';
  onboarding_completed_at: string | null;
  requests: number;
  input_tokens: number;
  output_tokens: number;
  billable_units: number;
  estimated_cost_cents: number;
  meter_failures: number;
  last_used_at: string | null;
}

export function useAiAssistantUsage(days = 30) {
  return useQuery({
    queryKey: ['ai-assistant-usage', days],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_admin_ai_assistant_usage' as never, { p_days: days } as never);
      if (error) throw error;
      return (data || []) as unknown as AiAssistantUsageRow[];
    },
  });
}
